import { ServerSubstitutionKeywordsStringAssets } from "../../../../../assets/stringAssets";
import { generateStandardEmailClosingHtml, generateStandardEmailOpeningHtml } from "../commonEmailBodyFragments";

/**
 * @function generateEmailBodyHtmlForSigninWithEmailLink. Generates the Html body of a notification email for a sign-in with email link
 * @param {string} emailAddress The email address of the user requesting the sign-in with email link.
 * @param {string} firstName The first name of the user requesting the sign-in with email link.
 * @param {string} lastName The last name of the user requesting the sign-in with email link.
 * @returns {string} A string with the Html body of the email message to be sent.
 */
export function generateEmailBodyHtmlForSigninWithEmailLink(emailAddress: string, firstName: string, lastName: string): string {

  const recipientUserName: string = `${firstName} ${lastName}`;

  // *** Compose the email Body in HTML format ***
  let emailBodyHtml = generateStandardEmailOpeningHtml(recipientUserName);

  // inform about sign-in with email link
  emailBodyHtml += `<p>We have received a request to permit signing into ${ServerSubstitutionKeywordsStringAssets.ProjectName} for this email account (${emailAddress}) using an email link. `;
  emailBodyHtml += `You may sign-in without a password by <a href='${ServerSubstitutionKeywordsStringAssets.SignInWithEmailLink}'>clicking on this sign-in link</a> that will `;
  emailBodyHtml += `re-direct you to a browser and automatically sign you into ${ServerSubstitutionKeywordsStringAssets.ProjectName}. </p>`;

  emailBodyHtml += `<p>If you did not request this sign-in link, you can safely ignore this email.</p>`;

  emailBodyHtml += `<p>We hope you enjoy using ${ServerSubstitutionKeywordsStringAssets.ProjectName}! </p>`;

  emailBodyHtml += generateStandardEmailClosingHtml();

  // return the email content
  return emailBodyHtml;
}
